import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://tradeoff.blueshuckconsulting.com";
const OG_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/b363e899-6dc0-40f9-8880-7c946e009774/images/e87e904feb654915f943ff2b215379f28d9e5d256d0c6595a367ef4b330c0f8f.png";

export const Seo = ({ title, description, path = "", noindex = false, jsonLd = null }) => {
  const url = `${SITE}${path}`;
  const fullTitle = title ? `${title} | TradeOff by Blue Shuck` : "TradeOff by Blue Shuck";
  const blocks = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="TradeOff by Blue Shuck" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      {blocks.map((b, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(b)}</script>
      ))}
    </Helmet>
  );
};

export default Seo;
